import { render, staticRenderFns } from "./LdmtLavReport.vue?vue&type=template&id=0fb701cc"
import script from "./LdmtLavReport.vue?vue&type=script&lang=js"
export * from "./LdmtLavReport.vue?vue&type=script&lang=js"
import style0 from "./LdmtLavReport.vue?vue&type=style&index=0&id=0fb701cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports